(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  const h = document.querySelector('.announcement-bar')?.offsetHeight || 0;
  document.documentElement.style.setProperty('--announcement-bar-height', `${h}px`);

  } catch(e) { console.error(e); }
})();
})();
